import React, { useState } from "react";
import styled, { createGlobalStyle } from "styled-components/macro";
import Sidebar from "../components/Sidebar";
import Header from "../components/AppBar";
import Footer from "../components/Footer";

import { spacing } from "@material-ui/system";
import {
    Hidden,
    CssBaseline,
    Paper as MuiPaper,
    withWidth,
} from "@material-ui/core";

import { isWidthUp } from "@material-ui/core/withWidth";
import { useLocation } from "react-router-dom";
import loginService from "../domain/services/login.service";
import yearlyEventsService from "../domain/services/marketing/events/yearly.events.service";
import SupportChatWidget from "../components/users/SupportChatWidget/SupportChatWidget";
import ContactsGateHandler from "../components/correspondents/contacts.gate.handler";
import SellerWorkSignal from "../components/crm/crm.seller.work.signal";
import OrbitaConnectionGate from "../components/crm/crm.orbita.connection.gate";
import useRouteLayoutProps from "../routes/useRouteLayoutProps";

const drawerWidth = 258;

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${(props) => props.theme.palette.background.default};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }

  .MuiAccordion-root:before {
    height: 0 !important;
  }

  /* Works on Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: background: #bdbdbd #f7f9fc;
  }
  
  /* Works on Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 10px;
  }
  
  *::-webkit-scrollbar-track {
    background: #f7f9fc;
  }
  
  *::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 5px;
    border: 3px solid #f7f9fc;
  }
  .swal2-container {
    z-index: 2147483647 !important;
  };
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.backgroundColors} !important;
  margin-top: 50px;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }
`;

const PageLayout = ({ children, routes, width }) => {

    const routeLayoutProps = useRouteLayoutProps(routes);
    const isInvoiceOnly = loginService.isInvoiceOnlyFaciliter();
    const { hideWhatsAppButton = false, hideHeader = false } = routeLayoutProps;
    const hideSideBar = routeLayoutProps.hideSideBar || isInvoiceOnly;
    const [mobileOpen, setMobileOpen] = useState(false);

    const currentEvent = yearlyEventsService.getCurrentEvent();
    const isMarketplace = useLocation().pathname === '/marketplace';

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const renderWhatsAppButton = () => {

        if (loginService.isInternal() || !loginService.isLogin() || hideWhatsAppButton || loginService.isFaciliter()) return <></>;

        return (
            <SupportChatWidget forceAuthenticated />
        );
    };

    return (
        <Root>
            <CssBaseline />
            <GlobalStyle />
            {!isInvoiceOnly && <ContactsGateHandler />}
            <SellerWorkSignal />
            {!hideSideBar && (
                <Drawer>
                    <Hidden mdUp implementation="js">
                        <Sidebar
                            routes={routes}
                            PaperProps={{ style: { width: drawerWidth } }}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                        />
                    </Hidden>
                    <Hidden smDown implementation="css">
                        <Sidebar
                            routes={routes}
                            PaperProps={{ style: { width: drawerWidth } }}
                        />
                    </Hidden>
                </Drawer>
            )}
            <AppContent>
                {!hideHeader && <Header onDrawerToggle={handleDrawerToggle} showAdvertising={true} hideSideBar={hideSideBar} />}
                <MainContent p={isWidthUp("lg", width) ? 12 : 5} backgroundColors={isMarketplace && currentEvent?.backgroundColor ? currentEvent?.backgroundColor : '#F7F9FC'} style={hideHeader ? { marginTop: 0 } : undefined}>
                    <OrbitaConnectionGate>{children}</OrbitaConnectionGate>
                    {renderWhatsAppButton()}
                </MainContent>
                <Footer />
            </AppContent>
        </Root>
    );
};

export default withWidth()(PageLayout);
